import React from 'react';
import styles from './EllipsisAnimated.module.css';

export const EllipsisAnimated: React.FC<{ className: string }> = ({
    className,
}) => {
    return (
        <div className={`${className} ${styles.ellipsisAnimated}`}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};
